<template>
  <div @click="showField">
    <div class="field-wrap" v-if="customField.field_type == 'contacts'">
        <div class="col-md-12">
          <div class="row mb-4">
              <div class="contact-box">
                <h5>
                  {{ customField.name }}
                  <a
                    v-b-tooltip.hover
                    title="Edit contact"
                    class="edit-contact-btn"
                    href="#"
                    @click.prevent="updateContact(customField.id)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                </h5>
                <strong>{{ customField.company_name }}</strong>
                <br />
                <span>{{ customField.phone }}</span>
                <br />
                <span>{{ customField.email_address }}</span>
                <br />
                <a
                  v-b-tooltip.hover
                  title="Remove contact"
                  href="#"
                  class="delete-contact-btn"
                  @click="onShowRemoveContact(customField.id)"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
              </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showRemoveContact" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveContact" ok-title="Yes, Remove">
        <p>Are you sure you want to unassign this contact?</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters } from "vuex";
import customStatusOptionPartial from "./StatusOptions";

export default {
  name: "FullContactField",
  props: ["customField", "users", "deliverableId"],
  data() {
    return {
      editing: false,
      showRemoveContact:false,
      newContactId: "",
      newContactName: "",
      addContactFlag: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ],
    };
  },
  computed: {
    ...mapGetters(["allUsers","allContacts"]),
    _: function() {
      return _;
    },
    selectedUser: {
      get() {
        return this.allUsers.find(user => user.id == this.customField.value);
      },
      set(newValue) {
        this.customField.userName = newValue.name;
        this.customField.value = newValue.id;
      }
    },
  },
  components: {
  },
  methods: {
    ...mapActions(["addDeliverableSpokesperson","removeDeliverableSpokesperson"]),
    customLabel({ name }) {
      return name
    },
    customDateFormat(date) {
      return this.$moment(date).format("DD MMM, YYYY");
    },
    parseValue(str) {
      try {
          return JSON.parse(str);
      } catch (e) {
          return false;
      }
    },
    showField() {
      if(this.editing) return
      this.editing = true;
      this.$nextTick(() => {
        if (typeof this.$refs.customInput != "undefined") {
          if (typeof this.$refs.customInput.quill != "undefined") {
            this.$refs.customInput.quill.focus();
          } else if (typeof this.$refs.customInput.$el != "undefined") {
            this.$refs.customInput.$el.focus();
          } else {
            this.$refs.customInput.focus();
          }
        } else if(typeof this.$refs.customDatepicker != "undefined") {
          // this.$refs.customDatepicker.$children[0].$emit('showCalendar')
          this.$refs.customDatepicker.showCalendar()
          this.$refs.customDatepicker.$el.querySelector('input').focus()
        }
      });
    },
    getStatuses(dataJson) {
      let data = this.parseValue(dataJson),
        options = [];
      data.forEach(status => {
        options.push(status.name)
      });
      return options;
    },
    outside() {
      this.editing = false;
    },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.fieldContacts.$el.focus();
      });
    },
    createContact(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$bvModal.show("createContactModal");
      //this.$store.commit("toggleAddContactModal");
    },
    updateContact(contactId) {
      this.$store.state.currentContactId = contactId;
      this.$store.state.currentFieldKey = this.fieldKey;
      this.$bvModal.show("editContactModal");
      //this.$store.commit("toggleEditContactModal");
    },
    contactsNotAdded() {
      let addedContacts = this.customField.value,
        allContacts = this.allContacts,
        addedIds = [];

      _.forEach(addedContacts, function(n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function(o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },
    addContact() {
      if (typeof this.customField.value == "undefined") {
        this.customField.value = [];
      }
      this.customField.value.push(this.newContactId);
      this.addDeliverableSpokesperson({contactData: this.newContactId, deliverableId: this.deliverableId});
      this.editing = false;
      // this.customField.value.push(payload);
      // this.$store.dispatch("addContact", payload);
      this.newContactId = "";
    },
    onShowRemoveContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

  },
  mounted() {
    let self = this;
    window.addEventListener("keyup", function(e) {
      if (e.keyCode === 27) {
        self.editing = false;
      }
    });
  }
};
</script>

<style>
</style>